// extracted by mini-css-extract-plugin
export default {"add-schema-property-dialog":"yg0obr"};